module.exports = __webpack_public_path__ + "img/biorrolo1.c846a5fb.png";